// Shared "last seen" formatting. The app-wide chat poll pings the Worker for
// every logged-in device every ~45s, so anything within a few minutes is
// effectively online.
const ONLINE_MS = 3 * 60_000;

export function presenceStatus(iso) {
  if (!iso) return null;
  const diff = Date.now() - new Date(iso).getTime();
  if (diff < ONLINE_MS) return { online: true, text: 'в сети' };
  if (diff < 60 * 60_000) return { online: false, text: `${Math.round(diff / 60_000)} мин назад` };
  if (diff < 24 * 3_600_000) return { online: false, text: `${Math.round(diff / 3_600_000)} ч назад` };
  const days = Math.round(diff / 86_400_000);
  return { online: false, text: `${days} ${days === 1 ? 'день' : 'дн'} назад` };
}
